import React, { useEffect } from 'react';
// import InputMask from 'react-input-mask';
import { useParams } from 'react-router-dom';
import moment from 'moment';
// import CKEditor from 'ckeditor4-react';
import validator from 'validator';
import { createState, useState, Downgraded } from '@hookstate/core';
import
{
    Box,
    Divider,
    Typography,
    TextField,
    Select,
    MenuItem,
    Autocomplete,
    FormControl,
    InputLabel,
    Switch,
    Button
} from '@mui/material';
import { makeStyles } from '@mui/styles'; 
import CircularProgress from '@mui/material/CircularProgress';
// import stores
import { exitTheme } from '../../hookState/ThemeState';
// import utility and constants
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
// import shared components
import Title from '../../sharedcomponents/title/title';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import UploadImagePopup from '../../sharedcomponents/uploadImage/uploadImagePopup';
import ProfileImage from '../../sharedcomponents/profileImage/profileImage';
// import images
import pic from '../../assets/images/pic.svg';

// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import TinyMCEEditor from '../../sharedcomponents/tinymceEditor/tinymce';
import PhoneNumber from '../../sharedcomponents/PhoneNumber/phoneNumber';
import MUIDatePicker from '../../sharedcomponents/datePicker';
import dayjs from 'dayjs';

const useStyles = makeStyles({
    pic: {
        height: 100,
        width: 100,
    },
    add: {
        height: 20,
        width: 20,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});

const profileState = createState({
    userID: 0,
    firstName: '',
    lastName: '',
    dob: '',
    vaccinated: '',
    email: '',
    contactNo: '1',
    userAddress: '',
    picture: '',
    src: '',
    aboutInfo: '',
    roleID: 0,
    tags: [],
    withTeam: 0,
    leagueID: '',
    teamID: 0,
    isDisable: false,
    active: 1,
    picUrl: '',
});

const CreateUser = (props) =>
{
    const classes = useStyles();
    let params = useParams();
    const state = useState(profileState);
    const tags = useState(null);
    const roles = useState(null);
    // const userRole = useState(0);
    // const userTag = useState([]);
    const leagues = useState(null);
    const teams = useState(null);
    const userInfo = useState(null);
    const editUserInfo = useState(null);
    const loading = useState(false);
    const openUpload = useState(false);
    // const authState = useAuthState();
    const [existingMail, setExistingMail] = React.useState('')
    const [fNameErr, setFNameErr] = React.useState('');
    const [lNameErr, setLNameErr] = React.useState('');
    const [emailErr, setEmailErr] = React.useState('');
    const [dobErr, setDOBErr] = React.useState('');
    const [phoneErr, setPhoneErr] = React.useState('');
    const [profilePic, setProfilePic] = React.useState('');
    // const [editorHTML, setEditorHTML] = React.useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [disableCreateAndInvBtn, setDisableCreateAndInvBtn] = React.useState(true);
    const [isInvitation, setIsInvitation] = React.useState(false);

    const prevState = useState(null)

    // const [active, setActive] = React.useState(false)

    useEffect( () => {
        const asyncfn = async () =>
    {
        await resetState();
        await exitTheme();
        await setRolesNTags();
        await getLeagues();
        const guserInfo = Helper.getStorage('userInfo');
        if (userInfo.get() == null)
        {
            userInfo.set(guserInfo);
        }
        // console.log("tags.get()",tags.get());
        if (params.userID && editUserInfo.get() == null && tags.get() != null)
        {
            // console.log("users",editUserInfo.get());
            ApiHelper.get(APIURLConstants.GET_USER(params.userID)).then(
                (res) =>
                {
                    if (res.data)
                    {
                        let data = res.data;
                        let seltags = data.tagsID ? data.tagsID.split(',') : [];
                        data.leagueID =
                            data.leagueID == null ? '' : data.leagueID;
                        data.withTeam =
                            data.withTeam == null ? 0 : data.withTeam;
                        data.userAddress =
                            data.userAddress == null ||
                                data.userAddress == 'null'
                                ? ''
                                : data.userAddress;
                        data.contactNo =
                            data.contactNo == null || data.contactNo == 'null'
                                ? ''
                                : data.contactNo;
                        state.picUrl.set(data.picUrl);
                        if (data.profilePicUrl)
                        {
                            const url = data.profilePicUrl;
                            setProfilePic(url);
                        }
                        delete data.tagsID;
                        if (data.leagueID)
                        {
                            getTeams(data.leagueID);
                        }
                        const getTags = tags
                            .attach(Downgraded)
                            .get()
                            .filter((item) =>
                                seltags.length > 0
                                    ? seltags.indexOf(item.tagID.toString()) >=
                                    0
                                    : false
                            );
                        data.tags = getTags;
                        data.aboutInfo = data.aboutInfo ? (data.aboutInfo.toLowerCase() == 'null' || data.aboutInfo.toLowerCase() == "<p>null</p>\n" ? '' : data.aboutInfo) : '';
                        editUserInfo.set(data);
                        let keys = Object.keys(data);
                        keys.forEach(key =>
                        {
                            data[key] = data[key] == null ? '' : data[key]
                        });
                        state.set(data); 
                        setExistingMail(data.email)
                    }
                    if (prevState.attach(Downgraded).get() === null)
                    {
                        let obj = res.data
                        console.log(obj);
                        let prevData = {
                            firstName: obj.firstName,
                            lastName: obj.lastName,
                            dob: Helper.FormatDate(obj.dob),
                            vaccinated: obj.vaccinated,
                            email: obj.email,
                            contactNo: obj.contactNo,
                            roleID: obj.roleID,
                            tags: obj.tags,
                            userAddress: obj.userAddress,
                            aboutInfo: obj.aboutInfo,
                            withTeam: obj.withTeam,
                            leagueID: obj.leagueID,
                            teamID: obj.teamID,
                            active: obj.active,
                            picUrl: obj.picUrl
                        }
                        prevState.set(prevData)
                    }
                }
            );
        } 
        else
        {
            await resetState();
        }
    }
    asyncfn();
}, []);

    const resetState = async () =>
    {
        state.set({
            userID: 0,
            firstName: '',
            lastName: '',
            dob: null,
            vaccinated: '',
            email: '',
            contactNo: '1',
            userAddress: '',
            picture: '',
            src: '',
            aboutInfo: '',
            roleID: 0,
            tags: [],
            withTeam: 0,
            leagueID: '',
            teamID: 0,
            isDisable: false,
            active: 1,
            picUrl: '',
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const email = state.email.get().trim();
        const flag = email != '' ? validateEmail(email) : true;
        const emlErr = flag ? '' : 'Please enter valid Email';
        setEmailErr(emlErr);
        if (email.length > 0 && flag) {
            setDisableCreateAndInvBtn(false);
            if (existingMail != email) {
                ApiHelper.get(APIURLConstants.GET_VALID_EMAIL(email)).then(
                    (res) => {
                        if (res.data) {
                            setEmailErr('This email already exists');
                            setDisableCreateAndInvBtn(true);
                        }
                        else {
                            setEmailErr('');
                            setDisableCreateAndInvBtn(false);        
                            payLoadData()
                        }
                    }
                );
            }else{
                setEmailErr('');
                setDisableCreateAndInvBtn(false);        
                payLoadData()
            }  
        } else {
            console.log("into update");
            setDisableCreateAndInvBtn(true);
        }
    };
    const payLoadData = () => {
        if (
            fNameErr.length > 0 ||
            lNameErr.length > 0 ||                                
            emailErr.length > 0
        ) {
            return false;
        }

        const documentData = new FormData();
        // let userReq = {};
        const setUserTags = state.tags.attach(Downgraded).get();
        const setUserTagsList =
            setUserTags.length > 0
                ? setUserTags.map((tag) => tag.tagID).join(',')
                : '';

        // userReq = { ...state.attach(Downgraded).get() };
        // userReq.tagsID = setUserTagsList;
        // userReq.createdBy = userInfo.get().userID;
        // userReq.active = state.active.get();
        // userReq.dob = Helper.FormatDateOnly(userReq.dob) == "" ? null : Helper.FormatDateOnly(userReq.dob)

        documentData.append('UserID', state.userID.get());
        documentData.append('FirstName', state.firstName.get());
        documentData.append('LastName', state.lastName.get());
        documentData.append('DOB', Helper.FormatDateOnly(state.dob.get()) == "" ? "" : Helper.FormatDateOnly(state.dob.get()));
        documentData.append('Email', state.email.get());
        documentData.append('ContactNo', state.contactNo.get());
        documentData.append('Vaccinated', state.vaccinated.get());
        documentData.append('RoleID', state.roleID.get());
        documentData.append('TagsID', setUserTagsList);
        documentData.append('UserAddress', state.userAddress.get());
        documentData.append('AboutInfo', state.aboutInfo.attach(Downgraded).get());
        documentData.append('WithTeam', state.withTeam.get());
        documentData.append('LeagueID', state.leagueID.get());
        documentData.append('TeamID', state.teamID.get());
        documentData.append('CreatedBy', userInfo.get().userID);
        documentData.append('Active', state.active.get());
        documentData.append('OldPicUrl', state.picUrl.get() ? state.picUrl.get() : '');
        documentData.append('PicUrl', state.picture.attach(Downgraded).get() ? state.picture.attach(Downgraded).get().name : (state.picUrl.get() ? state.picUrl.get() : ''));
        documentData.append('ProfilePic', state.picture.attach(Downgraded).get());

        loading.set(true);
        state.isDisable.set(true);

        ApiHelper.post(APIURLConstants.POST_USER, documentData)
            .then((res) => {
                if (res.data > 0) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: params.userID
                            ? 'User record updated successfully'
                            : 'User added successfully',
                    });
                    if (isInvitation) {
                        sendEmailnotifications(res.data, userInfo.get().userID);
                        setIsInvitation(false);
                    }

                    setTimeout(() => {
                        state.isDisable.set(false);
                        props.history.push(RouteConstants.USERS);
                    }, 2000);
                } else {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Error while creating a User',
                    });
                    state.isDisable.set(false);
                }
                loading.set(false);
                //resetState();
            })
            .catch((error) => {
                loading.set(false);
                state.isDisable.set(false);
                if (error.response && error.response.status === 401) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Access denied',
                    });
                } else {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Error while adding user',
                    });
                }
            });
    }
    const sendEmailnotifications = (id, userID) =>
    {
        ApiHelper.get(
            APIURLConstants.GET_USER_CONFIG(id, userID)
        ).then((res) =>
        {
            if (res.data)
            {
                let actualData = res.data;
                let formData = new FormData();
                // //Adding files to the form data
                formData.append('UserID', actualData.userID);
                formData.append('EmailID', actualData.toEmail);
                formData.append('CCEmailID', actualData.ccEmail ? actualData.ccEmail : '');
                formData.append('BCCEmailID', actualData.bccEmail ? actualData.bccEmail : '');
                formData.append('Body', actualData.body);
                formData.append('Subject', actualData.subject);
                formData.append('modifiedBy', userID);
                ApiHelper.post(APIURLConstants.POST_SEND_USER_INVITATION_EMAIL, formData)
                    .then((res) =>
                    {
                        if (res.data)
                        {
                            //  if (res.data == 'Email Sent successfully') {
                            //     props.setSnackBarProps({
                            //         ...props.snackBarProps,
                            //         openSnack: true,
                            //         variant: 'success',
                            //         message: 'Email Sent successfully',
                            //     });
                            // } else {
                            //     props.setSnackBarProps({
                            //         ...props.snackBarProps,
                            //         openSnack: true,
                            //         variant: 'error',
                            //         message: 'Email Sent Failed',
                            //     });
                            // } 
                        }
                    })
                    .catch((error) =>
                    {
                        console.log("error.response.data", error.response.data);
                        //  var msg = 'Error while Send Email';
                        // if (error.response.data == 'Please add subject Or body')
                        //     msg = 'Please add subject Or body';
                        // if (error.response && error.response.status === 401) {
                        //     props.setSnackBarProps({
                        //         ...props.snackBarProps,
                        //         openSnack: true,
                        //         variant: 'error',
                        //         message: 'Access denied',
                        //     });
                        // } else {
                        //     props.setSnackBarProps({
                        //         ...props.snackBarProps,
                        //         openSnack: true,
                        //         variant: 'error',
                        //         message: msg, //'Error while Send Email',
                        //     });
                        // }
                    });

            }
        });
    }
    // const handleSentInvSubmit = async (event) => {
    //     event.preventDefault();

    //     // console.log('event', event);

    //     if (
    //         fNameErr.length > 0 ||
    //         lNameErr.length > 0 ||
    //         dobErr.length > 0 ||
    //         emailErr.length > 0 ||
    //         phoneErr.length > 0
    //     ) {
    //         return false;
    //     }

    //     const documentData = new FormData();
    //     // let userReq = {};
    //     const setUserTags = state.tags.attach(Downgraded).get();
    //     const setUserTagsList =
    //         setUserTags.length > 0
    //             ? setUserTags.map((tag) => tag.tagID).join(',')
    //             : '';


    //     documentData.append('UserID', state.userID.get());
    //     documentData.append('FirstName', state.firstName.get());
    //     documentData.append('LastName', state.lastName.get());
    //     documentData.append('DOB', Helper.FormatDateOnly(state.dob.get()) == "" ? "" : Helper.FormatDateOnly(state.dob.get()));
    //     documentData.append('Email', state.email.get());
    //     documentData.append('ContactNo', state.contactNo.get());
    //     documentData.append('Vaccinated', state.vaccinated.get());
    //     documentData.append('RoleID', state.roleID.get());
    //     documentData.append('TagsID', setUserTagsList);
    //     documentData.append('UserAddress', state.userAddress.get());
    //     documentData.append('AboutInfo', state.aboutInfo.attach(Downgraded).get());
    //     documentData.append('WithTeam', state.withTeam.get());
    //     documentData.append('LeagueID', state.leagueID.get());
    //     documentData.append('TeamID', state.teamID.get());
    //     documentData.append('CreatedBy', userInfo.get().userID);
    //     documentData.append('Active', state.active.get());
    //     documentData.append('OldPicUrl', state.picUrl.get() ? state.picUrl.get() : '');
    //     documentData.append('PicUrl', state.picture.attach(Downgraded).get() ? state.picture.attach(Downgraded).get().name : (state.picUrl.get() ? state.picUrl.get() : ''));
    //     documentData.append('ProfilePic', state.picture.attach(Downgraded).get());

    //     loading.set(true);
    //     state.isDisable.set(true);

    //     ApiHelper.post(APIURLConstants.POST_USER, documentData)
    //         .then((res) => {
    //             if (res.data > 0) {
    //                 setSnackBarProps({
    //                     ...snackBarProps,
    //                     openSnack: true,
    //                     variant: 'success',
    //                     message: params.userID
    //                         ? 'User record updated successfully'
    //                         : 'User added successfully',
    //                 });
    //                 setTimeout(() => {
    //                     state.isDisable.set(false);
    //                     props.history.push(RouteConstants.USERS);
    //                 }, 2000);
    //                 sendEmailnotifications(res.data, userInfo.get().userID)
    //             } else {
    //                 setSnackBarProps({
    //                     ...snackBarProps,
    //                     openSnack: true,
    //                     variant: 'error',
    //                     message: 'Error while creating a User',
    //                 });
    //                 state.isDisable.set(false);
    //             }
    //             loading.set(false);
    //             //resetState();
    //         })
    //         .catch((error) => {
    //             loading.set(false);
    //             state.isDisable.set(false);
    //             if (error.response && error.response.status === 401) {
    //                 setSnackBarProps({
    //                     ...snackBarProps,
    //                     openSnack: true,
    //                     variant: 'error',
    //                     message: 'Access denied',
    //                 });
    //             } else {
    //                 setSnackBarProps({
    //                     ...snackBarProps,
    //                     openSnack: true,
    //                     variant: 'error',
    //                     message: 'Error while adding user',
    //                 });
    //             }
    //         });
    // };

    const setRolesNTags = async () =>
    {
        const rolesdata = ApiHelper.get(APIURLConstants.GET_USER_TYPE);
        const tagsdata = ApiHelper.get(APIURLConstants.GET_SYSTEM_TAGS);

        await Promise.all([rolesdata, tagsdata]).then((data) =>
        {
            const rolesd = data[0].data;
            const tagsd = data[1].data;
            tags.set(tagsd);
            roles.set(rolesd);
        });
    };

    const getLeagues = () =>
    {
        ApiHelper.get(APIURLConstants.GET_LEAGUES).then((res) =>
        {
            if (res.data)
            {
                leagues.set(res.data);
            }
        });
    };

    const getTeams = (league) =>
    {
        ApiHelper.get(APIURLConstants.GET_TEAMS(league)).then((res) =>
        {
            if (res.data)
            {
                teams.set(res.data);
            }
        });
    };

    const handleCancel = () =>
    {
        resetState();
        props.history.push(RouteConstants.USERS);
    };

    const validateEmail = (value) =>
    {
        value = value.trim();
        if (validator.isEmail(value))
        {
            return true;
        }
        else
            return false;
    };

    const isEmailExist = () =>
    {
        const email = state.email.get().trim();
        const flag = email != '' ? validateEmail(email) : true;
        const emlErr = flag ? '' : 'Please enter valid Email';
        setEmailErr(emlErr);
        if (email.length > 0 && flag)
        {
            setDisableCreateAndInvBtn(false);
            if (existingMail != email)
            {
                ApiHelper.get(APIURLConstants.GET_VALID_EMAIL(email)).then(
                    (res) =>
                    {
                        if (res.data)
                        {
                            setEmailErr('This email already exists');
                            setDisableCreateAndInvBtn(true);
                            return true
                        }
                        else
                        {
                            setEmailErr('');
                            setDisableCreateAndInvBtn(false);
                            return false
                        }
                    }
                );
            }
        } else
        {
            setDisableCreateAndInvBtn(true);
            return true
        }
    };

    // const checkValidPhone = () =>
    // {    
    //     const phone = state.contactNo.get(); 
    //     if (phone === "" || phone === "1")
    //     {
    //         setPhoneErr('please enter phone number');
    //         return { flag: 'false' };
    //     } else
    //     {
    //         setPhoneErr('');
    //     }
    // };
    const handleBlur = (dateval) =>
    {
        // let dateval = event.target.value;
        // console.log("dateval",dateval);
        if (!moment(dateval).isValid())
        {
            setDOBErr('Please enter valid date');
            return { flag: 'false' };
        } 
        // else if (dateval.indexOf('/') > -1)
        // {
        //     let chkdate = dateval.split('/');
        //     if (chkdate[2] && chkdate[2] < 1900)
        //     {
        //         setDOBErr('Please enter date > 1900');
        //     } else
        //     {
        //         setDOBErr('');
        //     }
        // }
         else
        {
            setDOBErr('');
        }

    };

    const handleImageUpload = () =>
    {
        openUpload.set(true);
    };
    const handleClose = () =>
    {
        openUpload.set(false);
        handleDisableBtn()
    };
    const changeProfilePhoto = (file) =>
    {
        state.picture.set(file);
        if (file.size >= 5000000)
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Image File is too big',
            });
        } else
        {
            state.src.set(URL.createObjectURL(file));
            handleClose();
        }
    };
    const handleStatusChange = () =>
    {
        state.active.set(state.active.get() == 1 ? 0 : 1);
        handleDisableBtn();

        // if (active == true)
        // {
        //     state.active.set(1)
        // } else
        // {
        //     state.active.set(0)

        // }
    }

    const handleDisableBtn = () =>
    {
        if (params.userID > 0)
        {
            const prevData = prevState.attach(Downgraded).get();
            console.log(prevData);
            let currentData = {
                firstName: state.get().firstName,
                lastName: state.get().lastName,
                dob: Helper.FormatDate(state.get().dob),
                vaccinated: state.get().vaccinated,
                email: state.get().email,
                contactNo: state.get().contactNo,
                roleID: state.get().roleID,
                tags: state.get().tags,
                userAddress: state.get().userAddress,
                aboutInfo: state.get().aboutInfo,
                withTeam: state.get().withTeam,
                leagueID: state.get().leagueID,
                teamID: state.get().teamID,
                active: state.get().active,
                picUrl: state.picture.attach(Downgraded).get()
            }

            if (JSON.stringify(prevData) === JSON.stringify(currentData))
            {
                setDisableBtn(true)
            } else
            {
                setDisableBtn(false)
            }
        }

    }

    const setEditorValue = (value) => {
        state.aboutInfo.set(value);
        handleDisableBtn();
    }
    const HandleDateOfBirth =(value) => {
        // console.log(value);
        state.dob.set(dayjs(value).format('YYYY-MM-DDTHH:mm:ss')); 
        handleDisableBtn();
    }
    console.log(state.dob.get(), dobErr);
    return (
        <Box sx={{ width: '100%' }}>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box className="contentBox">
                    <Box
                        component="form"
                        sx={{ width: '100%' }}
                        onSubmit={handleSubmit}>
                        <Title
                            title={params.userID ? 'Edit User' : 'Add New User'}
                            sx={{
                                ml: 0,
                                p: 2,
                            }}
                            px={0}
                        />
                        <Divider light={false} sx={{}} flexItem />
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                marginTop: 2,
                            }}>
                            <Box
                                sx={{
                                    flex: 0.2,
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                }}>
                                <label>
                                    {state.src.get() ? (
                                        <ProfileImage
                                            handleClick={handleImageUpload}
                                            src={state.src.get()}
                                        />
                                    ) : profilePic ? (
                                        <ProfileImage
                                            handleClick={handleImageUpload}
                                            src={profilePic}
                                        />
                                    ) : (
                                        <ProfileImage
                                            handleClick={handleImageUpload}
                                            src={pic}
                                        />
                                    )}

                                    {/* <input
                                        type="file"
                                        id="imageUpload"
                                        accept=".png, .jpg, .jpeg"
                                        hidden
                                        onChange={fileUploadHandler}
                                    /> */}
                                </label>

                                <Typography
                                    variant="h4"
                                    fontSize={{ xs: '12px', md: '12px' }}
                                    fontWeight={500}
                                    paddingTop={1}
                                    color="primary">
                                    Add Headshot
                                </Typography>
                                <Typography
                                    variant="p"
                                    fontSize={{ xs: '10px', md: '10px' }}
                                    fontWeight={400}
                                    paddingTop={1}>
                                    Maximum upload file size: 5 MB.
                                </Typography>
                                <Typography
                                    variant="p"
                                    fontSize={{ xs: '10px', md: '10px' }}
                                    fontWeight={400}
                                    paddingTop={0}>
                                    File format: jpg, png, gif
                                </Typography>
                                {/* <Typography
                                    variant="h4"
                                    fontSize={{ xs: '12px', md: '10px' }}
                                    fontWeight={500}
                                    paddingLeft={1}
                                    paddingTop={1}
                                    pb={1}>
                                    Photo size should be 300px
                                </Typography> */}
                                {params.userID > 0 ? (
                                    <Box
                                        sx={{
                                            mt: 2,
                                            display: 'flex',
                                            width: '100%',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            flexDirection: 'row',
                                        }}>
                                        <InputLabel
                                            sx={{
                                                width: '100%',
                                                textAlign: 'right',
                                                ml: 1,
                                                fontWeight: 'bold',
                                            }}
                                            id="demo-simple-select-label">
                                            Status:
                                        </InputLabel>
                                        <FormControl
                                            sx={{
                                                width: '100%',
                                                alignItems: 'left',
                                            }}>
                                            <Switch
                                                checked={
                                                    state.active.get()
                                                        ? true
                                                        : false
                                                }
                                                onChange={handleStatusChange}
                                                inputProps={{
                                                    'aria-label': 'controlled',
                                                }}
                                            // color='#90EE90'
                                            />
                                        </FormControl>
                                    </Box>
                                ) : null}
                            </Box>
                            <Box sx={{ flex: 0.8 }}>
                                <Box
                                    sx={{
                                        flex: 1,
                                        flexDirection: {
                                            xs: 'column',
                                            md: 'row',
                                        },
                                        display: 'flex',
                                    }}>
                                    <Box
                                        sx={{
                                            flex: 0.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}>
                                        <TextField
                                            required
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '100%',
                                                },
                                                mr:2,
                                                marginBottom: {
                                                    xs: '1rem',
                                                    md: '0',
                                                },
                                            }}
                                            size="small"
                                            label="First Name"
                                            value={state.firstName.get()}
                                            onChange={(event) =>
                                            {
                                                let str = event.target.value;
                                                str = str.replace(/^\s+/g, '');

                                                if (
                                                    validator.isAlpha(
                                                        str,
                                                        'en-US',
                                                        { ignore: ' ' }
                                                    )
                                                )
                                                {
                                                    setFNameErr('');
                                                } else
                                                {
                                                    setFNameErr(
                                                        'Please enter valid first name'
                                                    );
                                                }
                                                state.firstName.set(str);
                                                handleDisableBtn();
                                            }}
                                            inputProps={{
                                                maxLength: 50,
                                            }}
                                            error={
                                                fNameErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                            helperText={
                                                fNameErr.length > 0
                                                    ? fNameErr
                                                    : ''
                                            }
                                        />
                                    </Box>
                                    <Box sx={{ flex: 0.5, display: 'flex' }}>
                                        <TextField
                                            required
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '100%',
                                                },
                                                ml:2
                                            }}
                                            size="small"
                                            label="Last Name"
                                            value={state.lastName.get()}
                                            onChange={(event) =>
                                            {
                                                let str = event.target.value;
                                                str = str.replace(/^\s+/g, '');

                                                if (
                                                    validator.isAlpha(
                                                        str,
                                                        'en-US',
                                                        { ignore: ' ' }
                                                    )
                                                )
                                                {
                                                    setLNameErr('');
                                                } else
                                                {
                                                    setLNameErr(
                                                        'Please enter valid last name'
                                                    );
                                                }
                                                state.lastName.set(str);
                                                handleDisableBtn();
                                            }}
                                            inputProps={{
                                                maxLength: 50,
                                            }}
                                            error={
                                                lNameErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                            helperText={
                                                lNameErr.length > 0
                                                    ? lNameErr
                                                    : ''
                                            }
                                        />
                                    </Box>
                                </Box>

                                <Typography
                                    variant="h4"
                                    fontSize={{ xs: '12px', md: '10px' }}
                                    fontWeight={400}
                                    color="#AC394C"
                                    paddingLeft={1}
                                    marginTop={2}
                                    pb={1}>
                                    Note : Please note that, first & last name
                                    should be exact match to your official
                                    documents.
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        marginTop: 2,
                                        flexDirection: {
                                            xs: 'column',
                                            md: 'row',
                                        },
                                        flex: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            flex: 0.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            marginBottom: {
                                                xs: '1rem',
                                                md: '0',
                                            },
                                        }}>
                                            <MUIDatePicker 
                                                label="Date of Birth"
                                                value={state.dob.attach(Downgraded).get()}
                                                error={dobErr}
                                                setValue={(value) => HandleDateOfBirth(value)} 
                                            />
                                        {/* <LocalizationProvider
                                            dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                disableFuture
                                                label="Date of Birth"
                                                value={state.dob
                                                    .attach(Downgraded)
                                                    .get()}
                                                inputProps={{ readOnly: true }}
                                                onChange={(newValue) =>
                                                {state.dob.set(parseISO(newValue, "MM/DD/YYYY", new Date()));
                                                    handleBlur(
                                                        Helper.FormatDate(
                                                            newValue
                                                        )
                                                    );
                                                    handleDisableBtn();
                                                }}
                                                // onBlur={(event) =>
                                                //     handleBlur(event)
                                                // }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        sx={{
                                                            width: {
                                                                md: 'auto',
                                                                xs: '100%',
                                                            },
                                                        }}
                                                        size="small"
                                                        helperText={dobErr}
                                                        error={
                                                            dobErr.length > 0
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                )}
                                            />
                                        </LocalizationProvider> */}
                                    </Box>
                                    <Box sx={{ flex: 0.5, display: 'flex' }}>
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                                width: {
                                                    md: '100%',
                                                    xs: '100%',
                                                },
                                                ml:2
                                            }}>
                                            <InputLabel id="Vaccinated-select-small">
                                                {' '}
                                                Is Fully Vaccinated
                                            </InputLabel>
                                            <Select
                                                labelId="Vaccinated-select-small"
                                                id="demo-select-small"
                                                value={`${state.vaccinated.get()}`}
                                                label=" Is Fully Vaccinated"
                                                sx={{ minWidth: '40%' }}
                                                onChange={(event) =>
                                                {
                                                    state.vaccinated.set(
                                                        parseInt(
                                                            event.target.value
                                                        )
                                                    );
                                                    handleDisableBtn();
                                                }}>
                                                <MenuItem value={1}>
                                                    Yes
                                                </MenuItem>
                                                <MenuItem value={0}>
                                                    No
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        flex: 1,
                                        flexDirection: {
                                            xs: 'column',
                                            md: 'row',
                                        },
                                        display: 'flex',
                                        marginTop: 2,
                                    }}>
                                    <Box
                                        sx={{
                                            flex: 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between', 
                                        }}>
                                        <TextField
                                            required
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '100%',
                                                },
                                                marginBottom: {
                                                    xs: '1rem',
                                                    md: '0',
                                                },
                                            }}
                                            size="small"
                                            label="Email"
                                            value={state.email.get()}
                                            onChange={(event) =>
                                            {
                                                let str = event.target.value;
                                                str = str.replace(/^\s+/g, '');
                                                state.email.set(str);
                                                handleDisableBtn();
                                            }}
                                            onBlur={() => isEmailExist()}
                                            inputProps={{
                                                maxLength: 255,
                                            }}
                                            // disabled={params.userID > 0 ? true : false}
                                            error={
                                                emailErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                            helperText={
                                                emailErr.length > 0
                                                    ? emailErr
                                                    : ''
                                            }
                                        />
                                    </Box>
                                    <Box 
                                     sx={{
                                        flex: 1,
                                        display: 'flex',
                                        alignItems: 'left',
                                        flexDirection:'column',
                                        // justifyContent: 'space-between',
                                        width: {
                                            xs: '100%',
                                            md: '100%',
                                        },
                                        ml:4
                                    }}>
                                        {/* <InputMask
                                            mask="(999) 999-9999"
                                            value={state.contactNo.get()}
                                            defaultValue={state.contactNo.get()}
                                            onChange={(e) =>
                                            {
                                                const ph = e.target.value;
                                                state.contactNo.set(ph);
                                                checkValidPhone();
                                                handleDisableBtn();
                                            }}
                                        >
                                            {() => (
                                                <TextField
                                                    text
                                                    value={state.contactNo.get()}
                                                    label="Phone"
                                                    fullWidth
                                                    required
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{
                                                        width: {
                                                            md: '90%',
                                                            xs: '100%',
                                                        },
                                                    }}
                                                    error={
                                                        phoneErr.length > 0
                                                            ? true
                                                            : false
                                                    }
                                                    helperText={
                                                        phoneErr.length > 0
                                                            ? phoneErr
                                                            : ''
                                                    }
                                                />
                                            )}
                                        </InputMask> */}
                                        <PhoneNumber
                                            name={'usersContact'}
                                            placeholder="Phone"
                                            value={state.get().contactNo}
                                            onChange={(ph) =>
                                            {
                                                state.contactNo.set(ph);
                                                // checkValidPhone();
                                                handleDisableBtn();
                                            }} 
                                            // onBlue={() => checkValidPhone()}
                                            // required={true}
                                            // helperText={phoneErr}
                                            // error={phoneErr.length > 0 ? true : false}
                                        />
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        flex: 1,
                                        flexDirection: {
                                            xs: 'column',
                                            md: 'row',
                                        },
                                        display: 'flex',
                                        marginTop: 2,
                                    }}>
                                    <Box
                                        sx={{
                                            flex: 0.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                        {roles.get() ? (
                                            <FormControl
                                                sx={{
                                                    width: {
                                                        md: '100%',
                                                        xs: '100%',
                                                    },
                                                    marginBottom: {
                                                        xs: '1rem',
                                                        md: '0',
                                                    },
                                                }}>
                                                <InputLabel id="demo-simple-select-label">
                                                    Select Role
                                                </InputLabel>
                                                <Select
                                                    size="small"
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={state.roleID.get()}
                                                    label="Select Role"
                                                    onChange={(event) =>
                                                    {
                                                        state.roleID.set(
                                                            event.target.value
                                                        );
                                                        handleDisableBtn();
                                                    }}>
                                                    {roles
                                                        .attach(Downgraded)
                                                        .get()
                                                        .map((item, index) => (
                                                            <MenuItem
                                                                key={`role_${index}`}
                                                                value={
                                                                    item.typeID
                                                                }>
                                                                {item.typeName}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        ) : null}
                                    </Box>
                                    <Box sx={{ flex: 0.5, display: 'flex', ml:4 }}>
                                        {tags.get() ? (
                                            <Autocomplete
                                                multiple
                                                id="size-small-standard-multi"
                                                size="small"
                                                options={tags
                                                    .attach(Downgraded)
                                                    .get()}
                                                getOptionLabel={(option) =>
                                                    option.tagName
                                                }
                                                value={state.tags
                                                    .attach(Downgraded)
                                                    .get()}
                                                onChange={(event, newValue) =>
                                                {
                                                    state.tags.set(newValue);
                                                    handleDisableBtn();
                                                }}
                                                // defaultValue={[top100Films[1]]}
                                                renderInput={(params) => (
                                                    <TextField
                                                        sx={{
                                                            color: 'transparent',
                                                        }}
                                                        {...params}
                                                        label="Tags"
                                                        disabled
                                                        InputLabelProps={{
                                                            style: {
                                                                color: 'rgba(0, 0, 0, 0.6)',
                                                                opacity: 1,
                                                            },
                                                        }}
                                                    />
                                                )}
                                                sx={{
                                                    width: {
                                                        md: '100%',
                                                        xs: '100%',
                                                    },
                                                }}
                                            />
                                        ) : null}
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        flex: 1,
                                        flexDirection: 'row',
                                        display: 'flex',
                                        marginTop: 2,
                                    }}>
                                    <TextField
                                        size="small"
                                        sx={{
                                            width: { xs: '100%', md: '100%' },
                                        }}
                                        id="outlined"
                                        label="Address"
                                        value={state.userAddress.get()}
                                        onChange={(event) =>
                                        {
                                            state.userAddress.set(
                                                event.target.value
                                            );
                                            handleDisableBtn();
                                        }}
                                        inputProps={{
                                            maxLength: 255,
                                        }}
                                        multiline={true}
                                        minRows={3}
                                        maxRows={10}
                                    />
                                </Box>

                                <Box
                                    sx={{
                                        flex: 1,
                                        flexDirection: 'row',
                                        marginTop: 2,
                                        width: { xs: '100%', md: '99.5%' },
                                    }}>
                                    {/* <CKEditor
                                        data={state.aboutInfo
                                            .attach(Downgraded)
                                            .get()}
                                        onChange={(event) =>
                                            state.aboutInfo.set(
                                                event.editor.getData()
                                            )
                                        }
                                        config={{
                                            removeButtons: 'Subscript,Superscript',
                                            extraAllowedContent: '*{*};*(*);span{!color}'
                                        }}
                                    /> */}
                                    <TinyMCEEditor
                                        value={state.aboutInfo.attach(Downgraded).get()}
                                        setValue={setEditorValue}                
                                    />
                                    {/* <CKEditor
                                        editor={Editor}
                                        config={{
                                            image: {
                                                upload: [
                                                    'jpeg',
                                                    'png',
                                                    'gif',
                                                    'bmp',
                                                    'webp',
                                                    'tiff',
                                                ],
                                            },
                                            removeButtons:
                                                'Subscript,Superscript',
                                            extraAllowedContent:
                                                '*{*};*(*);span{!color}',
                                        }}
                                        data={state.aboutInfo
                                            .attach(Downgraded)
                                            .get()}
                                        onChange={(event, editor) =>
                                        {
                                            // console.log(event);
                                            state.aboutInfo.set(
                                                editor.getData()
                                            );
                                            handleDisableBtn();
                                        }}
                                    /> */}
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: {
                                            xs: 'column',
                                            md: 'row',
                                        },
                                        marginTop: 2,
                                    }}>
                                    <Box
                                        sx={{
                                            flex: 0.4,
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                        <FormControl
                                            sx={{
                                                width: {
                                                    md: '84%',
                                                    xs: '100%',
                                                },
                                                marginBottom: {
                                                    xs: '1rem',
                                                    md: '0',
                                                },
                                            }}>
                                            <InputLabel id="demo-simple-select-label">
                                                Are you associated with Team?
                                            </InputLabel>
                                            <Select
                                                size="small"
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={state.withTeam.get()}
                                                label="Are you associated with Team?"
                                                onChange={(event) =>
                                                {
                                                    state.withTeam.set(
                                                        event.target.value
                                                    );
                                                    if (
                                                        event.target.value == 0
                                                    )
                                                    {
                                                        state.leagueID.set('');
                                                        state.teamID.set(0);
                                                    }
                                                    handleDisableBtn();
                                                }}>
                                                <MenuItem value={1}>
                                                    Yes
                                                </MenuItem>
                                                <MenuItem value={0}>
                                                    No
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box
                                        sx={{
                                            flex: 0.3,
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                        <FormControl
                                            sx={{
                                                width: {
                                                    md: '84%',
                                                    xs: '100%',
                                                },
                                                marginBottom: {
                                                    xs: '1rem',
                                                    md: '0',
                                                },
                                            }}>
                                            <InputLabel id="demo-simple-select-autowidth-label">
                                                League
                                            </InputLabel>
                                            <Select
                                                size="small"
                                                labelId="demo-simple-select-autowidth-label"
                                                value={
                                                    state.leagueID.get()
                                                        ? state.leagueID.get()
                                                        : ' '
                                                }
                                                label="League"
                                                onChange={(event) =>
                                                {
                                                    state.leagueID.set(
                                                        event.target.value
                                                    );
                                                    getTeams(
                                                        event.target.value
                                                    );
                                                    handleDisableBtn();
                                                }}
                                                disabled={
                                                    state.withTeam.get()
                                                        ? false
                                                        : true
                                                }>
                                                {leagues.get() &&
                                                    leagues
                                                        .attach(Downgraded)
                                                        .get()
                                                        .map((item, index) => (
                                                            <MenuItem
                                                                key={`league_${index}`}
                                                                value={
                                                                    item.type
                                                                }>
                                                                {item.name}
                                                            </MenuItem>
                                                        ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box
                                        sx={{
                                            flex: 0.3,
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                        <FormControl
                                            sx={{
                                                width: {
                                                    md: '100%',
                                                    xs: '100%',
                                                },
                                            }}>
                                            <InputLabel id="demo-simple-select-label">
                                                Team
                                            </InputLabel>
                                            <Select
                                                size="small"
                                                labelId="demo-simple-select-label"
                                                value={state.teamID.get()}
                                                label="Team"
                                                onChange={(event) =>
                                                {
                                                    state.teamID.set(
                                                        event.target.value
                                                    );
                                                    handleDisableBtn();
                                                }}
                                                disabled={
                                                    state.withTeam.get()
                                                        ? false
                                                        : true
                                                }>
                                                {teams.get() &&
                                                    teams
                                                        .attach(Downgraded)
                                                        .get()
                                                        .map((item, index) => (
                                                            <MenuItem
                                                                key={`league_${index}`}
                                                                value={
                                                                    item.teamID
                                                                }>
                                                                {item.teamShort}
                                                                -{item.teamName}
                                                            </MenuItem>
                                                        ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Divider light={false} sx={{ marginTop: 2 }} flexItem />
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                justifyContent: 'end',
                                pr: 3,
                            }}>
                            <ButtonContainer
                                //handleClick={handleClick}
                                handleCancel={handleCancel}
                                buttonText={params.userID ? 'Update' : 'Create'}
                                disableButton={state.isDisable.get()}
                                disableUpdateButton={
                                    params.userID > 0 ? disableBtn : false
                                }
                            />
                            <Button
                                variant="contained"
                                type="submit"
                                onClick={() => setIsInvitation(true)}
                                disabled={
                                    params.userID > 0 ? true : disableCreateAndInvBtn
                                }
                                sx={{
                                    width: '150px',
                                    height: '40px',
                                    marginTop: '16px',
                                    display: props.hideCancel ? 'none' : '',
                                }}>
                                {props.cancelText !== undefined
                                    ? props.cancelText
                                    : 'Create & Invite'}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {openUpload.get() && (
                <UploadImagePopup
                    open={openUpload.get()}
                    // setViewFile={setViewFile}
                    title="Upload Image"
                    handleClose={handleClose}
                    changeProfilePhoto={changeProfilePhoto}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                />
            )}
        </Box>
    );
};

export default {
    routeProps: {
        path: [RouteConstants.CREATE_USER, RouteConstants.EDIT_USER],
        component: CreateUser,
    },
    name: 'CreateUser',
};
